export default __webpack_public_path__ + "static/h07-bc2949050f602c0c9e09b62365e1b42e.png";